import {useTranslation} from 'next-i18next';
import ViewedProductsSwiper from './viewed-products-swiper';
import {useProductListBySkuList} from '@/framework/product';
import CustomerProductsGrid from '@/_application/pages/customer/components/customer-product-grid/customer-product-grid';
import {VIEWED_PRODUCT_KEY} from '@/lib/constants';
import {useEffect} from 'react';

const ViewedProducts = ({variant = 'slider'}: {variant?: 'slider' | 'list'}) => {
    const {t} = useTranslation('common');
    const {fetchData, data, isLoading} = useProductListBySkuList();

    useEffect(() => {
        const viewedProductsString = localStorage.getItem(VIEWED_PRODUCT_KEY);
        const skusArray = viewedProductsString ? JSON.parse(viewedProductsString) : [];
        fetchData(skusArray);
    }, []);
    if (!data?.length && !isLoading) return <></>;
    if (variant === 'slider') {
        return (
            <div className="mt-5 flex w-full justify-center bg-[#20C4F433] px-5 pb-2 pt-5">
                <div className="w-full px-5 lg:w-[1024px] xl:w-[1204px]">
                    <h2 className="text-[1.375rem] font-extrabold text-primary">{t('viewed-products')}</h2>
                    <ViewedProductsSwiper data={data} isLoading={isLoading} />
                </div>
            </div>
        );
    } else if (variant === 'list') {
        return <CustomerProductsGrid products={data} isLoading={isLoading} />;
    }
    return <>Invalid position</>;
};

export default ViewedProducts;
